import React from 'react';
import { useTranslation } from 'react-i18next';
import { decrypt } from '~/Utils/index';

// import Logo from '~/components/Logo';

import { Container } from './styles';

const image = '/assets/images/cropped-small-logo-32x32.png';

export default function Footer() {
  const { t } = useTranslation();
  const version = decrypt(localStorage.getItem('@App:version'));
  return (
    <Container>
      {t('messages:desenvolvimento')} <img src={image} alt="w2z" style={{ margin: '0 5px' }} /> | {version}
    </Container>
  );
}
